<template>
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.9507 1.63628L6.00098 6.58603L1.05123 1.63627" stroke="black" stroke-width="2"/>
  </svg>
</template>

<script>
  export default {
    name: "ArrowDown"
  }
</script>

<style scoped>

</style>